var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    fill: "white",
    stroke: "#2C2C2C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.36523 11.6243L11.638 4.35156",
    stroke: "#FF5E5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.638 11.6243C11.638 11.4005 6.78948 6.68256 4.36523 4.35156",
    stroke: "#FF5E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteImage);
export default __webpack_public_path__ + "static/media/deleteImage.e0fb3e3cc12f2aa6488b10f64ae57f26.svg";
export { ForwardRef as ReactComponent };